import { Injectable, ProviderToken, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Feature } from '../../mtp-common/models';
import { UserService } from '../../mtp-common/services';

export class FeatureGuard {
    public static forFeature(feature: Feature): ProviderToken<CanActivate> {
        @Injectable({
            providedIn: 'root',
        })
        class FeatureCheck implements CanActivate {
            private readonly router = inject(Router);
            private readonly userService = inject(UserService);

            public canActivate(
                _route: ActivatedRouteSnapshot,
                _state: RouterStateSnapshot
            ): Observable<boolean | UrlTree> {
                return this.userService
                    .hasFeature(feature)
                    .pipe(map((hasFeature) => hasFeature || this.router.createUrlTree(['/'])));
            }
        }

        return FeatureCheck;
    }
}
